export default "__VITE_ASSET__3hFEw_yR__"